export default __webpack_public_path__ + "static/base-plus-6-9b7218b1748e583515246dde52803c50.jpg";